
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2022
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': '고정',
	'find_label': '찾기',
	'findCancelLabel': '취소',
	'dataPaneLabel': '데이터',
	'sourcePaneLabel': '선택된 소스',
	'sourcePaneContentLabel': '소스 선택',
	'emptySourcePaneTitle': '소스 선택',
	'emptySourcePaneCaption': '소스를 클릭하여 선택하고 대시보드를 빌드하는 데 사용할 데이터를 추가합니다.',
	'addDataSource': '소스 선택',
	'addDataDashboardCoachMarkContents': '데이터 패널의 데이터를 끌어서 대시보드에 놓으십시오.',
	'addDataStoryCoachMarkContents': '데이터 패널의 데이터를 끌어서 스토리에 놓으십시오.',
	'addDataCoachMarkTitle': '데이터 추가',
	'selectSourcesText': '데이터 소스를 선택하고 추가하여 %{app}을(를) 빌드합니다.',
	'selectSourcesLabel': '소스 선택',
	'dataPreparationTitle': '데이터 준비',
	'dataPreparationCaption': '데이터 준비가 완료되면 여기에 데이터가 표시됩니다.',
	'dataPreparationProgress': '%{percentage}% 준비됨...',
	'dataPreparationSourceError': '"%{sourceName}"에 대한 데이터 준비가 완료되지 않았습니다.',
	'dataPreparationStarted': '"%{sourceName}"에 대한 데이터 준비가 진행 중입니다. 대시보드 기능은 데이터 준비가 완료되면 사용할 수 있습니다.',
	'dataPreparationComplete': '"%{sourceName}"에 대한 데이터 준비가 완료되었습니다. 이제 모든 대시보드 기능과 함께 사용할 수 있습니다.',
	'preparingData': '데이터 준비 중...',
	'moserUnsupportedSourceType': '이 데이터 소스 유형은 지원되지 않습니다.',
	'errorSourcesTitle': '데이터 트리 로드 실패',
	'errorLoadingDataSources': '데이터 세트 목록을 로드하는 중에 오류가 발생했습니다.',
	'errorLoadingDataTree': '트리를 로드하는 중에 오류가 발생했습니다.',
	'dataSetPaneLastUpdated': '마지막 업데이트: %{date}',
	'dataSourcePaneDateUnknown': '알 수 없음',
	'moreTitle': '자세히',
	'backLabel': '되돌아가기',
	'addDataSourceDialogTitle': '소스 선택',
	'addDataSourceDialogButtonLabel': '추가',
	'dlg_use': '사용',
	'dlg_RelinkDataSourceTitle': '다음으로 데이터 세트 "%{dataSourceName}" 대체...',
	'propertiesDialogTitle': '특성',
	'missingDataSetData': '이 데이터 세트의 데이터를 사용할 수 없습니다. 데이터 세트를 새로 고치거나 소스 액세스에 대해 관리자에게 문의하십시오.',
	'errorMessageTitle': '오류',
	'calculation_navigation_in_use': '계산, 필터 또는 탐색 경로를 삭제하면 삭제된 항목을 참조하는 모든 시각화가 무효화됩니다. 정말로 삭제하시겠습니까?',
	'delete_confirm': '삭제 확인',
	'previewUnavailable': '데이터 트레이와 글로벌 필터는 이 패키지 유형에서 사용 불가능합니다.',
	'contextualGridTabName': '데이터 시각화',
	'DATA_TRAY_no_data_text': '현재 데이터가 없습니다.',
	'contextualGridMenuLabel': '시각화 데이터 메뉴',
	'contextualGridExport': '내보내기',
	'nullValueText': '널',
	'relationships_title': '관계',
	'forecastDetailsTabName': '예측 통계 상세 정보',
	'forecastDetailsModelLabel': '모델',
	'forecastDetailsQualityMetricLabel': '정확도 측정',
	'forecastDetailsSmoothingCoefLabel': '매개변수',
	'forecastDetailsDiagnostics': '진단',
	'forecastDetailsForecastLabel': '예측',
	'forecastDetailsStatusLabel': '상태',
	'forecastDetailsAccuracyPercentLabel': '정확도 %',
	'forecastDetailsTrendLabel': '추세',
	'forecastDetailsSeasonLabel': '계절성',
	'forecastDetailsSeasonalPeriodLabel': '계절 기간',
	'forecastDetailsAlphaLabel': '알파',
	'forecastDetailsBetaLabel': '베타',
	'forecastDetailsGammaLabel': '감마',
	'forecastDetailsPhiLabel': '파이',
	'forecastDetailsMissingCount': '누락된 수',
	'forecastDetailsSeriesLengthLabel': '계열 길이',
	'forecastDetailsIgnoredPeriods': '무시된 기간',
	'forecastDetailsTrendStrength': '경향 강도',
	'forecastDetailsSeasonalityStrength': '계절성 강도',
	'forecastDetailsTimeDeltaUnit': '날짜/시간 간격',
	'forecastDetailsNotes': '참고',
	'DatasetRefresh_AmbiguousConnection': ' 다음 연결 문제를 해결하려면 \'데이터 세트 편집\'을 사용하십시오: %{errorMessage}'
});
